import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const pinToBackAnimation = {
  z: -200,
  opacity: 0,
  filter: 'blur(5px)',
};

const mm = gsap.matchMedia();

gsap.registerPlugin(ScrollTrigger);

const setupCardsAnimation = () => {
  mm.add('(min-width: 767px)', () => {
    const triggers = document.querySelectorAll('[gsap="cards_trigger"]');

    triggers.forEach((trigger) => {
      const topRow = trigger.querySelector('[gsap="cards_top_row"]');

      if (topRow) {
        gsap.set(topRow, {
          z: 0,
          opacity: 1,
          filter: 'none',
        });

        const cardsTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: trigger,
            start: 'center 40%',
            end: 'bottom top',
            scrub: true,
            pin: true,
            pinSpacing: false,
            // anticipatePin: ,
            markers: false,
          },
        });
        cardsTimeline.to(topRow, pinToBackAnimation);
      }
    });
  });
};

window.Webflow ||= [];
window.Webflow.push(() => {
  function initializeAnimations() {
    // if (window.animationsInitialized) {
    //   return;
    // }

    const context = gsap.context(() => {
      // Initialize GSAP animations
      setupCardsAnimation();

      //   ScrollTrigger.refresh();
    });

    window.animationContext = context;

    window.animationsInitialized = true;
  }

  if (window.animationContext) {
    window.animationContext.revert();
    window.animationContext.kill();
    console.log('killed and reverted');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAnimations);
  } else {
    initializeAnimations();
  }
});
